

import { PrincipalDocumentosLista } from "../../../../features/auditoria/domain/models/documentos_lista";
import { IGetAllListagemDocUseCaseUseCase } from "../../../presentation/useCases/read/get_all_principal_doc_use_case";
import { ICommonsRepository } from "../../repositories/commons_repository";
import { BasePaginatedUseCase } from "../base_paginated_use_case";


export class GetAllListagemDocUseCaseUseCase
  extends BasePaginatedUseCase<PrincipalDocumentosLista>
  implements IGetAllListagemDocUseCaseUseCase {
  constructor(private readonly repository: ICommonsRepository) {
    super();
  }

  async getAllListagemDoc(
    Categoria: string,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository
      .getAllListagemDoc(
        Categoria,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
